import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab-config"
//
// Reorders the rows of the profile tab-configuration form. Deliberately NOT the
// shipped `sortable` controller: that one PUTs to a per-item URL the moment you
// drop, which suits persisted records with their own endpoints. These rows are
// fields in a form that saves on Submit, so nothing should hit the server until
// the organizer presses Save — and Cancel has to mean cancel.
//
// Up/down buttons rather than drag: the server reads the submitted ORDER, so the
// DOM order is the source of truth either way, and buttons are reachable by
// keyboard, which drag-only reordering is not.
export default class extends Controller {
  static targets = ["row"]

  move(event) {
    const row = event.currentTarget.closest("[data-tab-config-target='row']")
    if (!row) return

    const direction = event.currentTarget.dataset.direction
    const sibling = direction === "up"
      ? row.previousElementSibling
      : row.nextElementSibling
    if (!sibling) return

    if (direction === "up") {
      row.parentNode.insertBefore(row, sibling)
    } else {
      row.parentNode.insertBefore(sibling, row)
    }

    // Keep focus on the button that was pressed so repeated presses keep working
    // and the position isn't lost for keyboard users.
    event.currentTarget.focus()
    this.syncDisabled()
  }

  connect() {
    this.syncDisabled()
  }

  // The first row can't move up and the last can't move down.
  syncDisabled() {
    const rows = this.rowTargets
    rows.forEach((row, index) => {
      const up = row.querySelector("[data-direction='up']")
      const down = row.querySelector("[data-direction='down']")
      if (up) up.disabled = index === 0
      if (down) down.disabled = index === rows.length - 1
    })
  }
}
